export default __webpack_public_path__ + "static/media/arrowIconWhite.32add456.svg";